import { useEffect, useRef, useState } from "react";
import useApi from "../hooks/use-api";
import ClientInformationSkeleton from "./skeletons/clientinformationskeleton";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import QuickLinks from "./quicklinks";
import { useRecordRecentClient } from "../new/recent-clients.query";

const ClientInformationExpanded = ({ApplicationId}) => {
    const {getRequest} = useApi();
    const [clientInformation,setClientInformation] = useState(null);
    const [dataLoaded,setDataloaded] = useState(false);
    const getRequestRef = useRef(getRequest);
    const lastRecordedRecentClientRef = useRef(null);
    const { mutate: recordRecentClient } = useRecordRecentClient();

    const navigate = useNavigate();

    useEffect(() => {
        getRequestRef.current = getRequest;
    },[getRequest]);

    useEffect(() => {
        setDataloaded(false);

        const Get = async() => {
            const [data, status] = await getRequestRef.current("ClientInformationExpanded", {ApplicationId: ApplicationId,timestamp: Date.now()}); 

            if(status === 200){
                setClientInformation(data);
            }
            else{
                setClientInformation(null)
            }

            setDataloaded(true);
        }

        Get();
    },[ApplicationId])

    useEffect(() => {
        if(clientInformation){
            const recentClientKey = `application:${clientInformation.applicationid}`;

            if (lastRecordedRecentClientRef.current === recentClientKey) {
                return;
            }

            lastRecordedRecentClientRef.current = recentClientKey;
            recordRecentClient({
                applicationid: clientInformation.applicationid
            });
        }
    },[ApplicationId, clientInformation, recordRecentClient]);

    return(
        !dataLoaded
        ?
            <ClientInformationSkeleton boxCount={6} />
        :
        clientInformation !== null &&
        <div className="clientInformationSticky">
            <div className="clientInformationStyle">
                <h3 className="clientInformationTitle">
                    Client Information
                </h3>
                <div className="infoItemBox">
                    <h5>Name</h5>
                    <p className="infoItemDataBody">{clientInformation.name}</p>
                </div>
                <div className="infoItemBox">
                    <h5>Application #</h5>
                    <p className="infoItemDataBody">{clientInformation.applicationid}</p>
                </div>
                <div className="infoItemBox">
                    <h5>Application Date</h5>
                    <p className="infoItemDataBody">{clientInformation.applicationdate}</p>
                </div>
                <div className="infoItemBox">
                    <h5>Medicaid #</h5>
                    <p className="infoItemDataBody">{clientInformation.medicaidid}</p>
                </div>
                <div className="infoItemBox">
                    <h5>Application Status</h5>
                    <p className="infoItemDataBody">{clientInformation.applicationstatus !== null ? clientInformation.applicationstatus : <>Not Started</>}</p>
                </div>
                {/* <div className="infoItemBox">
                    <h5>Login Name</h5>
                    <p className="infoItemDataBody">{clientInformation.loginname}</p>
                </div> */}
                <Button type="button" variant="link" className="p-0" style={{textDecoration: 'none',fontSize: '0.9em'}} onClick={() => navigate('/Client/ClientSearch', { state: { restoreClientSearch: true } })}>Return to Client Search</Button>
            </div>
            <QuickLinks />
            {/* {
                !clientInformation.iscurrent &&
                <Alert variant="danger">
                    <Alert.Heading>Outdated Client Application</Alert.Heading>
                    <p>
                        You are currently viewing a Client Application that is not the most current.
                    </p>
                </Alert>
            } */}
        </div>
    )
}

export default ClientInformationExpanded;
